const rocketsToggle = () => {
    $(".rocket-industry-btn").click(function(){
        $(this).parent().find('.rockets-industry-hidden').slideToggle();      
    });
}

export default rocketsToggle;